<script setup>
import {inject, reactive} from 'vue';
import moment from 'moment';
import { map } from 'lodash';
import TicketsDatatable from "@/Pages/PartnerSupport/Tickets/Partials/TicketsDatatable.vue";

const trans = inject('trans');

const props = defineProps({
  filters: {
    type: Object,
    default: () => ({}),
  },
  statusOptions: {
    type: Array,
    required: true,
  },
  priorityOptions: {
    type: Array,
    required: true,
  },
  filterSelections: {
    type: Array,
    required: true,
  },
});


const headers = [
  { text: '#', value: 'id', align: 'center', sortable: true },
  { text: trans('__JSON__.Partner'), value: 'partner.name', align: 'start', sortable: true },
  { text: trans('__JSON__.Subject'), value: 'subject', align: 'start', sortable: true },
  { text: trans('__JSON__.Customers'), value: 'customers', align: 'start' },
  { text: trans('__JSON__.Date created'), value: 'dateCreated', align: 'start', sortable: true },
  { text: trans('__JSON__.Date updated'), value: 'dateUpdated', align: 'start', sortable: true },
  { text: trans('__JSON__.Latest replied date'), value: 'dateLatestReplied', align: 'start', sortable: true },
  { text: trans('__JSON__.Priority'), value: 'priority', align: 'start', sortable: true },
  { text: trans('__JSON__.Status'), value: 'status', align: 'start', sortable: true },
  { text: trans('__JSON__.Assignee'), value: 'assignee', align: 'start', sortable: true },
  { text: '', value: 'action', align: 'start' },
];

const filterFieldsOptions = {
  'statusOptions': props.statusOptions,
  'priorityOptions': props.priorityOptions
}
const filterFields = reactive({
  unassigned: {
    id: 'unassigned',
    name: trans('__JSON__.Unassigned'),
    type: 'checkbox',
    labelText: trans('__JSON__.Unassigned'),
  },
  WaitingReplyCustomer: {
    id: 'WaitingReplyCustomer',
    name: trans('__JSON__.Waiting for reply - customer'),
    type: 'checkbox',
    labelText: trans('__JSON__.Waiting for reply - customer'),
  },
  WaitingReplyAPIcenter: {
    id: 'WaitingReplyAPIcenter',
    name: trans('__JSON__.Waiting for reply - APIcenter'),
    type: 'checkbox',
    labelText: trans('__JSON__.Waiting for reply - APIcenter'),
  },
  lastAction24Hours: {
    id: 'lastAction24Hours',
    name: trans('__JSON__.Last action > 24 hours'),
    type: 'checkbox',
    labelText: trans('__JSON__.Last action > 24 hours'),
  },
  lastAction48Hours: {
    id: 'lastAction48Hours',
    name: trans('__JSON__.Last action > 48 hours'),
    type: 'checkbox',
    labelText: trans('__JSON__.Last action > 48 hours'),
  },
  assignedToMe: {
    id: 'assignedToMe',
    name: trans('__JSON__.Assigned to me'),
    type: 'checkbox',
    labelText: trans('__JSON__.Assigned to me'),
  },
  dateCreated: {
    id: 'dateCreated',
    name: trans('__JSON__.Date created'),
    type: 'text',
    labelText: trans('__JSON__.Date created'),
    helpText: trans('__JSON__.Use format {yyyy-mm-dd}'),
  },
  dateUpdated: {
    id: 'dateUpdated',
    name: trans('__JSON__.Date updated'),
    type: 'text',
    labelText: trans('__JSON__.Date updated'),
    helpText: trans('__JSON__.Use format {yyyy-mm-dd}'),
  },
  dateLatestReplied: {
    id: 'dateLatestReplied',
    name: trans('__JSON__.Date latest replied'),
    type: 'text',
    labelText: trans('__JSON__.Date latest replied'),
    helpText: trans('__JSON__.Use format {yyyy-mm-dd}'),
  },
});

const prepareUserNames = (item) => {
  let customers = item.customers

  let usersNames = customers.length > 0 ? map(customers, 'name').join(', ') : '-'

  return usersNames.length > 50 ? usersNames.substring(0, 50) + '...' : usersNames
}
</script>

<template>
  <div>
    <TicketsDatatable
      :filters="filters"
      :filterFields="filterFields"
      :filterFieldsOptions="filterFieldsOptions"
      :filterSelections="filterSelections"
      :headers="headers"
      :loading="false"
      :search-placeholder="trans('__JSON__.Search in tickets')"
      can-select-per-page
    >
      <template #item-date-created="{ item }">
        {{ moment(item.dateCreated).format('YYYY-MM-DD') }}
      </template>
      <template #item-date-updated="{ item }">
        {{ moment(item.dateUpdated).format('YYYY-MM-DD') }}
      </template>
      <template #item-date-latest-replied="{ item }">
        <span v-if="item.dateLatestReplied">
          {{ moment(item.dateLatestReplied).format('YYYY-MM-DD HH:mm:ss') }}
        </span>
        <span v-else>-</span>
      </template>
      <template #item-customers="{ item }">
        <p v-if="item.impactValue > 1">
          {{ prepareUserNames(item) }}
        </p>
        <p v-else>
          {{ item.impact }}
        </p>
      </template>
      <template #item-action="{ item }">
        <inertia-link :href="route('partner-support.tickets.show-communications', item.id)" class="tile-button">
          <svg class="icon">
            <use xlink:href="#eye-icon"></use>
          </svg>
        </inertia-link>
      </template>
    </TicketsDatatable>
  </div>
</template>
